import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function ForbiddenPage() {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-center">
      <span className="font-mono text-xs uppercase tracking-wide text-muted-foreground">
        403
      </span>
      <h1 className="text-xl font-semibold tracking-tight">Not authorized</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        You don&apos;t have permission to view this page. If you believe this is
        a mistake, ask a workspace admin.
      </p>
      <Button asChild size="sm" variant="outline">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
